export default {"src":"https://fishbrain.com/_next/static/media/southCarolina.22ca970a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};